import { Flex } from '@cognite/cogs.js';
import styled from 'styled-components/macro';
import zIndex from 'utils/zindex';

export const ToolBarWrapperDefault = styled(Flex)`
  align-items: center;
  gap: 6px;
`;

export const ToolBarWrapperFixed = styled(Flex)`
  position: fixed;
  top: 0;
  gap: 3px;
  align-items: center;
  left: 45%;
  background-color: white;
  padding: 8px;
  border-radius: 6px;
  box-shadow: var(--cogs-z-8);
  z-index: ${zIndex.MAXIMUM};
`;
